import * as t from 'io-ts';
import { optional } from './helper';

const playerInfo = t.type( {
  displayName: t.string,
  shortName: t.string,
  bio: optional(t.string),
  sportsPersonId: t.string,
  playerId: t.string,
  firstName: t.string,
  lastName: t.string,
  fullName: t.string,
  countryISO3: optional(t.string),
  countryCode: optional(t.string),
});

const teamInfo = t.type( {
  icon: optional(t.string),
  shortName: t.string,
  sponsorshipName: optional(t.string),
  mobiName: optional(t.string),
  countryCode: t.string,
  countryISO3: t.string,
  name: t.string,
  teamCode: t.string,
  teamId: t.string,
  sportsTeamId: t.string,
});

const topScores = t.type( {
  player: playerInfo,
  team: teamInfo,
  position: t.number,
  goals: t.number,
});

const tournamentInfo = t.type( {
  name: t.string,
  icon: t.string,
  leaguePath: t.string,
  tournamentId: t.string,
  sportsTourId: t.string,
  sportsSeasonId: t.string,
  tournamentSlug: t.string,
  tournamentName: t.string,
  season: t.string,
});

const footballTopScorers = t.type( {
    tournament: tournamentInfo,
    topScores: t.array(topScores),
  });

export const footballTopScorersApiResponse = footballTopScorers;
export const topScorers = t.array(topScores);

export type TopScoresList = t.TypeOf<typeof topScorers>;
export type FootballTopScorers = t.TypeOf<typeof footballTopScorersApiResponse>;
